<template>
  <div class="doc-files">
    <div class="table-container">
      <el-table
        :data="tableData"
        border
        size="small"
        style="width: 100%"
        height="200"
      >
        <el-table-column type="index" label="#" width="50" align="center" />
        <el-table-column
          prop="originalFileName"
          :label="$l('INDEX.table_label_file_name') || '文件名'"
          min-width="100"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <div>{{ row.originalFileName }}</div>
            <div class="file-desc" v-if="row.fileDesc">
              {{ $l('INDEX.table_label_description') || '说明' }}：{{
                row.fileDesc
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="materialDocStatus"
          :label="$l('INDEX.table_label_status') || '状态'"
          width="80"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tag
              size="mini"
              :type="row.materialDocStatus === 'Y' ? 'success' : 'danger'"
            >
              {{ row.v_materialDocStatus }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="uploadByName"
          :label="$l('INDEX.table_label_updater') || '更新人'"
          width="150"
          align="center"
        >
          <template slot-scope="{ row }">
            <div>{{ row.uploadByName }}</div>
            <div class="upload-time">{{ row.uploadTime }}</div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$l('INDEX.table_label_operation') || '操作'"
          width="120"
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$l('INDEX.btn_edit') || '编辑'"
              placement="top"
              v-if="!disabled && row.materialDocStatus !== 'N'"
            >
              <i class="el-icon-edit tool-btn" @click="editFile(row)"></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$l('INDEX.btn_download') || '下载'"
              placement="top"
            >
              <i
                class="el-icon-download tool-btn"
                @click="downloadFile(row)"
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$l('INDEX.btn_delete') || '删除'"
              placement="top"
              v-if="!disabled && row.materialDocStatus !== 'N'"
            >
              <i
                class="el-icon-delete tool-btn"
                @click="del(row.materialDocCode)"
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- Upload Dialog -->
    <upload-files
      v-if="fileVisible"
      :materialCode="materialCode"
      :amzSkuCode="amzSkuCode"
      :amzSkuMaterialCode="amzSkuMaterialCode"
      :visible="fileVisible"
      @close="() => (fileVisible = false)"
      @reload="getDocData"
    />

    <!-- Edit Dialog -->
    <el-dialog
      :title="$l('INDEX.dialog_title_edit_file') || '编辑文件'"
      :visible.sync="editDialogVisible"
      width="600px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        :label-width="$l('INDEX.form_label_upload_file') ? '100px' : '100px'"
        size="small"
      >
        <el-form-item :label="$l('INDEX.form_label_upload_file') || '上传文件'">
          <el-upload
            ref="uploadEdit"
            :auto-upload="false"
            :on-change="onEditFileChange"
            :on-remove="onEditFileRemove"
            :on-exceed="onEditFileExceed"
            :file-list="editFileList"
            :limit="1"
            action="#"
          >
            <el-button size="small" type="primary" plain>{{
              $l('INDEX.btn_choose_file') || '选择文件'
            }}</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editDialogVisible = false">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" @click="saveEdit" :loading="uploading">
          {{ $l('INDEX.product_dialog_btn_confirm') || '确定' }}
        </el-button>
      </span>
    </el-dialog>
    <CloseDialog
      :backDialogVisible.sync="backDialogVisible"
      :title="'提示'"
      :bodyTitle="'请先保存基本信息'"
    />
  </div>
</template>
<script>
import UploadFiles from '../image-data/upload-file.vue'
import EditLoading from '@/mixins/edit-loading'
import CloseDialog from '../../../close-dialog/index.vue'
export default {
  props: {
    materialCode: String,
    amzSkuCode: String,
    amzSkuMaterialCode: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [EditLoading],
  components: { UploadFiles, CloseDialog },
  data() {
    return {
      tableData: [],
      fileVisible: false,
      editDialogVisible: false,
      backDialogVisible: false,
      editForm: {
        materialDocCode: '',
        materialCode: '',
        originalFileName: '',
        originalFileUrl: '',
        fileDesc: '',
        materialDocStatus: 'Y',
      },
      editFileList: [],
      uploading: false,
      removedCurrentFile: false,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (!this.materialCode) return
      this.getDocData()
    },
    getDocData() {
      this.$api
        .materialInfoDocListApi({ materialCode: this.materialCode })
        .then((res) => {
          this.tableData = res.body.data
        })
    },
    uploadFile() {
      if (!this.materialCode) {
        this.backDialogVisible = true
        return
      }
      this.fileVisible = true
    },
    downloadFile(row) {
      const link = document.createElement('a')
      link.setAttribute('download', row.originalFileName)
      link.setAttribute('href', row.originalFileUrl)
      link.click()
    },
    editFile(row) {
      if (row.materialDocStatus === 'N') {
        this.$message.warning(
          this.$l('INDEX.tips_edit_disabled') || '该文件已禁用，无法编辑'
        )
        return
      }
      if (!this.materialCode) {
        this.$message.warning(
          this.$l('INDEX.tips_save_basic_info_first') || '请先保存基本信息'
        )
        return
      }

      // 使用 materialInfoDocDetailApi 加载详细数据
      this.$api
        .materialInfoDocDetailApi({ materialDocCode: row.materialDocCode })
        .then((res) => {
          if (res.status === 200) {
            const data = res.body
            this.editForm = {
              materialDocCode: data.materialDocCode,
              materialCode: data.materialCode,
              originalFileName: data.originalFileName,
              originalFileUrl: data.originalFileUrl,
              originalFileCode: data.originalFileCode,
              seqno: data.seqno,
              fileDesc: data.fileDesc || '',
              materialDocStatus: data.materialDocStatus || 'Y',
            }
            this.editFileList = []
            this.removedCurrentFile = false
            this.editDialogVisible = true
          }
        })
        .catch(() => {
          this.$message.error(
            this.$l('INDEX.tips_load_file_info_failed') || '加载文件信息失败'
          )
        })
    },
    downloadCurrentFile() {
      if (this.editForm.originalFileUrl) {
        const link = document.createElement('a')
        link.setAttribute('download', this.editForm.originalFileName)
        link.setAttribute('href', this.editForm.originalFileUrl)
        link.click()
      }
    },
    removeCurrentFile() {
      this.editForm.originalFileName = ''
      this.editForm.originalFileUrl = ''
      this.editForm.originalFileCode = ''
      this.removedCurrentFile = true
      this.editFileList = []
    },
    onEditFileChange(file, fileList) {
      this.editFileList = fileList
    },
    onEditFileRemove(file, fileList) {
      this.editFileList = fileList
    },
    onEditFileExceed(files) {
      // 当超出限制时，清空旧文件并添加新文件（实现覆盖更新）
      this.$refs.uploadEdit.clearFiles()
      this.editFileList = [{ raw: files[0], name: files[0].name }]
    },
    async saveEdit() {
      this.uploading = true

      if (this.removedCurrentFile && this.editFileList.length === 0) {
        this.$message.warning(
          this.$l('INDEX.tips_upload_new_file') || '请上传新文件'
        )
        this.uploading = false
        return
      }

      try {
        let uploadedFile = null

        // 如果选择了新文件，先上传
        if (this.editFileList.length > 0) {
          const file = this.editFileList[0]
          const uploadRes = await this.$api.SYS_UPLOAD(file.raw)
          uploadedFile = {
            originalFileCode: uploadRes.body.fileId,
            originalFileUrl: uploadRes.body.url,
            originalFileName: file.name,
          }
        }

        // 准备保存参数
        const params = {
          materialDocCode: this.editForm.materialDocCode,
          materialCode: this.editForm.materialCode,
          amzSkuCode: this.amzSkuCode,
          amzSkuMaterialCode: this.amzSkuMaterialCode,
          seqno: this.editForm.seqno,
          fileDesc: this.editForm.fileDesc,
          materialDocStatus: this.editForm.materialDocStatus,
        }

        // 如果有新上传的文件，使用新文件信息
        if (uploadedFile) {
          params.originalFileCode = uploadedFile.originalFileCode
          params.originalFileUrl = uploadedFile.originalFileUrl
          params.originalFileName = uploadedFile.originalFileName
        } else {
          // 否则保持原文件信息
          params.originalFileCode = this.editForm.originalFileCode
          params.originalFileUrl = this.editForm.originalFileUrl
          params.originalFileName = this.editForm.originalFileName
        }

        // 调用 materialInfoDocUploadApi 保存
        const res = await this.$api.materialInfoDocUploadApi(params)

        if (res.status === 200) {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.editDialogVisible = false
          this.editFileList = []
          this.getDocData()
        }
      } catch (error) {
        console.error(error)
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
      } finally {
        this.uploading = false
      }
    },
    del(materialDocCode) {
      if (!this.materialCode) {
        this.$message.warning(
          this.$l('INDEX.tips_save_basic_info_first') || '请先保存基本信息'
        )
        return
      }

      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()

        this.$api
          .materialInfoDocDelApi({
            materialDocCode,
            materialCode: this.materialCode,
            amzSkuCode: this.amzSkuCode,
            amzSkuMaterialCode: this.amzSkuMaterialCode,
          })
          .then(() => {
            this.loadingClose()

            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.getDocData()
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.doc-files {
  .table-container {
    min-height: 200px;
  }

  .file-desc {
    font-size: 12px;
    color: #909399;
  }

  .upload-time {
    font-size: 12px;
    color: #909399;
  }

  .tool-btn {
    width: 30px;
    height: 30px;
    font-size: 18px;
    text-align: center;
    line-height: 30px !important;
    cursor: pointer;
  }

  .tool-btn:hover {
    color: #409eff;
  }

  .current-file {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background-color: #f5f7fa;
    border-radius: 4px;

    span {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .no-data-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
    color: #e6a23c;
    font-size: 14px;

    i {
      font-size: 48px;
      margin-bottom: 12px;
    }

    p {
      margin: 0;
    }
  }
}
</style>
